import Section from 'app/frontend/base/components/Section'
import LinkedAccount from './components/LinkedAccount'

const UserLinkedAccounts = () => {
  return (
    <Section title='Profile'>
      <h2>Linked accounts</h2>

      <LinkedAccount type='Battle.net' />
      <LinkedAccount type='Discord' />
      <LinkedAccount type='Google' />
      <LinkedAccount type='Warcraft Logs' />
      <LinkedAccount type='Patreon' />
    </Section>
  )
}

export default UserLinkedAccounts
